import {Component} from '@angular/core';
import { NavController, NavParams } from "ionic-angular";
import { AuthService } from "../../../services/auth.service";
import { ResetPasswordData, User, ViewDidEnter } from "../../../app/app.interfaces";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormValidators } from "../../../form/form.validators";


@Component({
  selector: 'login',
  templateUrl: 'reset-password.html'
})
export class ResetPassword implements ViewDidEnter {

  resetToken: string = null;
  user: User = null;
  form: FormGroup;
  
  constructor(private nav: NavController, 
              private navParams: NavParams,
              private authService: AuthService,
              private ionic: IonicHelper,
              private formBuilder: FormBuilder) {
        
    
    
  }


  ionViewDidEnter(): void {
    
    this.authService.isLoggedIn().then((loggedIn)=> {     
      if(loggedIn) this.nav.setRoot('dashboard');
    });
    
    this.resetToken = this.navParams.get('resetToken');
    
    this.ionic.toggleLoader();
    
    this.authService.validatePasswordResetToken(this.resetToken).then((response)=>{
      this.user = response.user;
      this.ionic.toggleLoader(false);
      
    }, (error)=> {
      this.ionic.toggleLoader(false);
      this.ionic.alert('LOGIN.FORGOT_PASSWORD_ERROR.'+error).subscribe(() =>{
        this.nav.setRoot('login');
      });  
      
    });
    
    this.form = this.formBuilder.group({
        password: ['', Validators.compose([Validators.minLength(6),Validators.maxLength(60), Validators.required])],
        confirmPassword: ['', [Validators.required ]] 
    }, {
      validator: FormValidators.matchFields
    });
    
  }

  submitForm(){
        
    if(this.form.valid){
      this.ionic.toggleLoader();
      
      let postData: ResetPasswordData = {
        token: this.resetToken,
        password: this.form.value.password
      };
      
      this.authService.setNewPassword(postData).then((response: any) => {
        this.ionic.toggleLoader(false);
        this.ionic.alert('LOGIN.RENEW_PASSWORD_DONE', 'GLOBAL.SUCCESS').subscribe(() => {
          this.nav.setRoot('login');
        });
      }, (error) => {
        this.ionic.toggleLoader(false);
        //Todo maybe specific error msg
        console.error(error);
        this.ionic.alert('GLOBAL.GENERAL_ERROR');
      });
    }
    else {
      //Todo maybe specific error msg
      this.ionic.alert('LOGIN.RENEW_PASSWORD_FORM_INVALID');
    }
    
    
  }
  
  
  
  
}


// WEBPACK FOOTER //
// ./src/components/login/reset-password/reset-password.ts